import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {ErrorOutline as ErrorOutlineIcon} from 'views/icons';
import {Translate} from 'views/module';

import TimelineCard from './TimelineCard';
import {formatEventDateTime} from '../dateTime';

const ShiftMissedAction = (props) => {
  const {
    update,
    caregiverData,
    eventTimezone,
    titleExpression,
    descriptionExpression,
    iconColor,
  } = props;

  const timeString = formatEventDateTime(update.createdAt, eventTimezone);

  return (
    <TimelineCard
      timeString={timeString}
      icon={ErrorOutlineIcon}
      iconColor={iconColor}
      timeBg="#e0e0e0"
      title={<Translate expression={titleExpression} />}
    >
      <Typography variant="body2" color="text.secondary">
        <Translate
          expression={descriptionExpression}
          substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
        />
      </Typography>
    </TimelineCard>
  );
};

ShiftMissedAction.propTypes = {
  update: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  eventTimezone: PropTypes.string.isRequired,
  titleExpression: PropTypes.string.isRequired,
  descriptionExpression: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
};

ShiftMissedAction.defaultProps = {
  iconColor: '#f57c00',
};

export default ShiftMissedAction;
